import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { themr } from 'react-css-themr';
import { Motion, spring } from 'react-motion';
export const defaultDrawerTheme = {
    root: 'fixed top-0 right-0 w-100 vh-100 bg-near-white z-999 db dn-l',
    main: '',
    closeButtonWrapper: 'right-0 top-0 absolute ph3 pv2 h3 flex items-center',
    closeButton: 'pointer silver',
};
export const DumpDrawer = ({ isOpen, children, closeIcon = React.createElement(FontAwesomeIcon, { icon: "times", size: "2x", color: "silver" }), onClose, theme = {}, }) => {
    return (React.createElement(Motion, { defaultStyle: { x: -100 }, style: { x: spring(isOpen ? 0 : -100) } }, ({ x }) => (React.createElement("div", { className: theme.root, style: {
            transform: `translateX(${x}%)`,
        } },
        React.createElement("div", { className: theme.closeButtonWrapper },
            React.createElement("a", { className: theme.closeButton, onClick: onClose }, closeIcon)),
        React.createElement("div", { className: theme.main }, children)))));
};
const Drawer = themr('Drawer', {}, { composeTheme: 'softly' })(DumpDrawer);
export default Drawer;
//# sourceMappingURL=index.js.map